import React from "react";
import { withRouter } from "react-router-dom";

import Button from "@/components/UI/Button";
import { getCanStartCall } from "@/features/calendar/utils/general";
import Hr from "@/components/UI/Hr";
import images from "@/utils/images";
import { toTitleCase } from "@/utils/filters";

/**
 *
 * TODO: properly align three dots menu
 */
const SheduleListItemMobile = (props) => {
  const {
    allotted_time,
    callId,
    configs,
    currentTime,
    email,
    hideThreeDotsMenu,
    isAfternoon,
    isEvening,
    isMorning,
    isToday,
    menuClickHandler,
    provider_avatar,
    provider_name,
    provider_role,
    provider_username,
    scheduledDate,
    scheduledTime,
    timestamp,
  } = props;

  /**
   * Three dots menu in some places is not meant to be shown,
   * that's why it is conditionally rendered in return.
   */
  const threeDotsMenuJsx = (
    <span className="col-1 pl-1">
      <img
        alt="three dots menu"
        className="cursor px-2"
        onClick={(e) => menuClickHandler(e, callId, provider_username)}
        role="button"
        src={images("./icons/three-dots-menu.svg")}
      />
    </span>
  );

  const renderTimeOfDay = () => {
    if (isMorning) {
      return "Morning";
    }

    if (isAfternoon) {
      return "Afternoon";
    }

    if (isEvening) {
      return "Evening";
    }

    return "Time";
  };

  return (
    <div className="d-flex d-lg-none flex-column">
      <div className="d-flex w-100 mb-3 align-items-center">
        <div className="mr-3">
          <img
            alt="provider's avatar"
            src={provider_avatar || images("./common/avatar.png")}
            width="36"
          />
        </div>
        <div className="w-100">
          <div className="fs-16 tw:font-bold">{provider_name}</div>
          <div className="fs-14 ASCH-text-gry">{toTitleCase(provider_role.replace("_", " "))}</div>
          <Button
            className="Btn Btn-xs fs-12 Btn--pri"
            disabled={!getCanStartCall(currentTime, timestamp, allotted_time, email, configs)}
            onClick={() => props.history.push(`/app/video-call?callId=${callId}`)}
            type="button"
          >
            Join Now
          </Button>
        </div>
        {!hideThreeDotsMenu && threeDotsMenuJsx}
      </div>
      <div className="ml-5 pl-1 position-relative">
        <Hr />
        <div className="d-flex text-center mt-2 fs-14 tw:justify-center">
          <div className="w-50">
            <span className="ASCH-text-sec tw:font-bold">{isToday ? "Today" : "Date"}</span>
            <br />
            <span className="fs-16">{scheduledDate}</span>
          </div>
          <div className="w-50">
            <span className="ASCH-text-sec tw:font-bold">{renderTimeOfDay()}</span>
            <br />
            <span className="fs-16">{scheduledTime}</span>
          </div>
        </div>
        <div className="ASCH__vertical-bar position-absolute"></div>
      </div>
    </div>
  );
};

export default withRouter(SheduleListItemMobile);
